module.exports = __webpack_public_path__ + "public/images/netw-soon-tagline.9a8ab75c075244766773f0bcc1930c6a.webp";